export function getPluralName({
  prevSingularName,
  prevPluralName,
  nextSingularName,
}: {
  prevSingularName: string;
  prevPluralName?: string;
  nextSingularName: string;
}): string | undefined {
  if (nextSingularName && prevPluralName?.startsWith(prevSingularName)) {
    return prevPluralName.replace(prevSingularName, nextSingularName);
  }
  if (!nextSingularName) {
    return '';
  }
  return prevPluralName;
}
